(function () {
  // befüllen des Kreises mit den Namen
  const employees = document.querySelectorAll(
    ".com-employee-grid__single-employee"
  );
  const circle = document.getElementById("employee-grid-name");
  const employeeName = document.getElementById("employee-name");
  // const wrapper = document.getElementById("employee-grid-wrapper");

  for (let i = 0; i < employees.length; i++) {
    employees[i].addEventListener("mouseover", function (event) {
      const employee = event.target;
      circle.classList.remove("hover-leave");

      if (
        !employee.classList.contains("joblink-employee") &&
        typeof employee.dataset.employeename !== "undefined"
      ) {
        employeeName.innerHTML = employee.dataset.employeename;
      } else {
        employeeName.innerHTML = "";
        circle.classList.add("hover-joblink");
      }
    });

    employees[i].addEventListener("mouseleave", function (event) {
      const employee = event.target;
      circle.classList.add("hover-leave");

      if (employee.classList.contains("joblink-employee")) {
        circle.classList.remove("hover-joblink");
      } else {
        employeeName.innerHTML = "";
      }
    });

    // wrapper.addEventListener("mouseleave", function () {
    //   employeeName.innerHTML = "";
    //   circle.classList.add("hover-leave");
    // });

    // wrapper.addEventListener("mouseover", function () {
    //   circle.classList.remove("hover-leave");
    // });
  }

  // circle following cursor
  const employeeWrapper = document.getElementById("employee-grid-wrapper");
  const employeeCircle = document.getElementById("employee-grid-name");
  const onMouseMove = (e) => {
    employeeCircle.style.left = e.pageX + "px";
    employeeCircle.style.top = e.pageY + "px";
  };

  if (employeeWrapper) {
    employeeWrapper.addEventListener("mousemove", onMouseMove);
  }
})();
